// Mock data for Cameroon Property Portal

export const regions = [
  {
    name: 'Littoral',
    cities: ['Douala', 'Nkongsamba', 'Edéa', 'Limbé']
  },
  {
    name: 'Centre',
    cities: ['Yaoundé', 'Mbalmayo', 'Obala', 'Mfou']
  },
  {
    name: 'Ouest',
    cities: ['Bafoussam', 'Dschang', 'Foumban', 'Mbouda']
  },
  {
    name: 'Nord-Ouest',
    cities: ['Bamenda', 'Kumbo', 'Wum', 'Fundong']
  },
  {
    name: 'Sud-Ouest',
    cities: ['Buea', 'Kumba', 'Tiko', 'Limbe']
  },
  {
    name: 'Adamaoua',
    cities: ['Ngaoundéré', 'Meiganga', 'Tibati', 'Tignère']
  },
  {
    name: 'Est',
    cities: ['Bertoua', 'Batouri', 'Yokadouma', 'Abong-Mbang']
  },
  {
    name: 'Nord',
    cities: ['Garoua', 'Guider', 'Lagdo', 'Poli']
  }
];

// Property taxonomy — single source of truth lives in `property_taxonomy.json`.
// Backend reads the same file via `services/taxonomy.py`. Edit the JSON only.
import propertyTaxonomy from './property_taxonomy.json';

export const propertyTypes = propertyTaxonomy.types.map(({ value, label }) => ({ value, label }));
export const propertyPurposes = propertyTaxonomy.purposes.map(({ value, label }) => ({ value, label }));

export const mockProperties = [
  {
    id: '1',
    title: 'Villa Moderne à Bonapriso',
    description: 'Magnifique villa moderne de 5 chambres avec piscine, jardin spacieux et vue imprenable. Située dans le quartier résidentiel de Bonapriso à Douala.',
    type: 'villa',
    purpose: 'sale',
    price: 85000000,
    region: 'Littoral',
    city: 'Douala',
    neighborhood: 'Bonapriso',
    bedrooms: 5,
    bathrooms: 4,
    area: 350,
    landSize: 600,
    features: ['Piscine', 'Jardin', 'Garage 2 voitures', 'Cuisine équipée', 'Climatisation', 'Sécurité 24/7'],
    images: [
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800',
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800'
    ],
    agent: 'Immobilier Douala',
    agentPersonalName: 'Pierre Kamga',
    phone: '+237 6 99 99 99 99',
    agentEmail: 'contact@immobilierdouala.cm',
    agentWhatsapp: '+237699999999',
    agentPhoto: 'https://i.pravatar.cc/150?img=12',
    createdAt: '2026-01-15',
    featured: true
  },
  {
    id: '2',
    title: 'Appartement 3 Pièces Bastos',
    description: 'Bel appartement de 3 chambres au cœur de Bastos, Yaoundé. Idéal pour famille ou investissement locatif.',
    type: 'apartment',
    purpose: 'rent',
    price: 350000,
    region: 'Centre',
    city: 'Yaoundé',
    neighborhood: 'Bastos',
    bedrooms: 3,
    bathrooms: 2,
    area: 120,
    landSize: null,
    features: ['Balcon', 'Parking', 'Ascenseur', 'Sécurité'],
    images: [
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800',
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800'
    ],
    agent: 'Capital Immobilier',
    agentPersonalName: 'Marie Foko',
    phone: '+237 6 77 77 77 77',
    agentEmail: 'agent@property.cm',
    agentWhatsapp: '+237677777777',
    agentPhoto: 'https://i.pravatar.cc/150?img=20',
    createdAt: '2026-02-01',
    featured: true
  },
  {
    id: '3',
    title: 'Terrain à Bâtir - Odza',
    description: 'Terrain viabilisé de 500m² situé à Odza, Yaoundé. Parfait pour construction résidentielle.',
    type: 'land',
    purpose: 'sale',
    price: 15000000,
    region: 'Centre',
    city: 'Yaoundé',
    neighborhood: 'Odza',
    bedrooms: null,
    bathrooms: null,
    area: null,
    landSize: 500,
    features: ['Titre foncier', 'Eau', 'Électricité', 'Route goudronnée'],
    images: [
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800'
    ],
    agent: 'Terrains Plus',
    agentPersonalName: 'Jean-Claude Ndi',
    phone: '+237 6 55 55 55 55',
    agentEmail: 'agent@property.cm',
    agentWhatsapp: '+237655555555',
    agentPhoto: 'https://i.pravatar.cc/150?img=21',
    createdAt: '2026-01-28',
    featured: false
  },
  {
    id: '4',
    title: 'Duplex Standing Akwa',
    description: 'Superbe duplex de standing avec 4 chambres en suite, salon spacieux et terrasse panoramique à Akwa, Douala.',
    type: 'duplex',
    purpose: 'sale',
    price: 65000000,
    region: 'Littoral',
    city: 'Douala',
    neighborhood: 'Akwa',
    bedrooms: 4,
    bathrooms: 5,
    area: 280,
    landSize: 400,
    features: ['Terrasse', 'Cuisine américaine', 'Garage', 'Climatisation', 'Vue mer'],
    images: [
      'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800',
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800'
    ],
    agent: 'Prestige Immo',
    agentPersonalName: 'Sandrine Mbah',
    phone: '+237 6 88 88 88 88',
    agentEmail: 'agent@property.cm',
    agentWhatsapp: '+237688888888',
    agentPhoto: 'https://i.pravatar.cc/150?img=22',
    createdAt: '2026-02-10',
    featured: true
  },
  {
    id: '5',
    title: 'Studio Meublé Bonanjo',
    description: 'Studio moderne et meublé, proche du centre-ville de Douala. Idéal pour jeune professionnel.',
    type: 'studio',
    purpose: 'rent',
    price: 120000,
    region: 'Littoral',
    city: 'Douala',
    neighborhood: 'Bonanjo',
    bedrooms: 1,
    bathrooms: 1,
    area: 35,
    landSize: null,
    features: ['Meublé', 'Climatisation', 'WiFi', 'Parking'],
    images: [
      'https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=800'
    ],
    agent: 'Location Express',
    agentPersonalName: 'David Nguema',
    phone: '+237 6 44 44 44 44',
    agentEmail: 'agent@property.cm',
    agentWhatsapp: '+237644444444',
    agentPhoto: 'https://i.pravatar.cc/150?img=23',
    createdAt: '2026-02-15',
    featured: false
  },
  {
    id: '6',
    title: 'Maison 4 Chambres Bafoussam',
    description: 'Belle maison familiale avec grand jardin dans un quartier calme de Bafoussam.',
    type: 'house',
    purpose: 'sale',
    price: 35000000,
    region: 'Ouest',
    city: 'Bafoussam',
    neighborhood: 'Tamdja',
    bedrooms: 4,
    bathrooms: 3,
    area: 180,
    landSize: 450,
    features: ['Jardin', 'Garage', 'Véranda', 'Citerne d\'eau'],
    images: [
      'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800'
    ],
    agent: 'Immo Ouest',
    agentPersonalName: 'Aminata Sow',
    phone: '+237 6 33 33 33 33',
    agentEmail: 'agent@property.cm',
    agentWhatsapp: '+237633333333',
    agentPhoto: 'https://i.pravatar.cc/150?img=24',
    createdAt: '2026-02-08',
    featured: false
  },
  {
    id: '7',
    title: 'Appartement Luxe 2 Chambres',
    description: 'Appartement de luxe avec finitions haut de gamme, situé à Bamenda. Vue imprenable sur les montagnes.',
    type: 'apartment',
    purpose: 'rent',
    price: 280000,
    region: 'Nord-Ouest',
    city: 'Bamenda',
    neighborhood: 'Commercial Avenue',
    bedrooms: 2,
    bathrooms: 2,
    area: 95,
    landSize: null,
    features: ['Balcon', 'Parking', 'Sécurité', 'Vue montagne'],
    images: [
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800'
    ],
    agent: 'Bamenda Properties',
    agentPersonalName: 'Eric Tchouta',
    phone: '+237 6 22 22 22 22',
    agentEmail: 'agent@property.cm',
    agentWhatsapp: '+237622222222',
    agentPhoto: 'https://i.pravatar.cc/150?img=25',
    createdAt: '2026-02-12',
    featured: false
  },
  {
    id: '8',
    title: 'Villa 6 Chambres Bonanjo',
    description: 'Magnifique villa de prestige avec piscine, jacuzzi et salle de sport privée.',
    type: 'villa',
    purpose: 'sale',
    price: 120000000,
    region: 'Littoral',
    city: 'Douala',
    neighborhood: 'Bonanjo',
    bedrooms: 6,
    bathrooms: 6,
    area: 450,
    landSize: 800,
    features: ['Piscine', 'Jacuzzi', 'Salle de sport', 'Garage 3 voitures', 'Jardin tropical', 'Sécurité 24/7'],
    images: [
      'https://images.unsplash.com/photo-1613977257363-707ba9348227?w=800',
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800'
    ],
    agent: 'Luxury Estates Cameroon',
    agentPersonalName: 'Christelle Ngono',
    phone: '+237 6 11 11 11 11',
    agentEmail: 'agent@property.cm',
    agentWhatsapp: '+237611111111',
    agentPhoto: 'https://i.pravatar.cc/150?img=26',
    createdAt: '2026-01-20',
    featured: true
  }
];

export const newsArticles = [
  {
    id: '1',
    title: 'Le marché immobilier camerounais en pleine croissance',
    excerpt: 'Les investissements dans l\'immobilier continuent d\'augmenter au Cameroun, particulièrement à Douala et Yaoundé.',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800',
    category: 'Actualités',
    date: '2026-02-18'
  },
  {
    id: '2',
    title: 'Conseils pour acheter votre première maison',
    excerpt: 'Guide complet pour les primo-accédants : de la recherche au financement.',
    image: 'https://images.unsplash.com/photo-1554995207-c18c203602cb?w=800',
    category: 'Conseils',
    date: '2026-02-15'
  },
  {
    id: '3',
    title: 'Nouveaux quartiers résidentiels à Douala',
    excerpt: 'Découvrez les nouveaux développements immobiliers dans la capitale économique.',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800',
    category: 'Actualités',
    date: '2026-02-10'
  }
];

export const users = [
  {
    id: '1',
    name: 'Admin User',
    email: 'admin@camerproperty.cm',
    // Password is hashed in backend - use API for authentication
    role: 'admin',
    phone: '+237 6 00 00 00 00'
  },
  {
    id: '2',
    name: 'Jean Dupont',
    email: 'jean@example.cm',
    // Password is hashed in backend - use API for authentication
    role: 'user',
    phone: '+237 6 99 88 77 66'
  }
];

export const formatPrice = (price) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'XAF',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price).replace('XAF', 'FCFA');
};
